import { GridFilterModel } from "@mui/x-data-grid";
import { SortingModel } from "../../models/shared/SortingModel";
import { api_url } from "../../utils/ApiContext";
import { appendStringFilterToUri } from "../../utils/filtering";
import { BeneTipologiaModel } from "../../models/api/response/bene/BeneTipologiaModel";
import {
  FetchPaginatedApiModel,
  WithData,
  WithRecordID,
} from "../../models/shared/CommonModels";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../apiCommon";

const TAKE_LIMIT = 15;

const setQueryParameters = (
  filter: GridFilterModel | undefined,
  sort: SortingModel
) => {
  let uri = api_url.concat("/api/tipologiabene?");

  filter?.items.forEach((item) => {
    uri = appendStringFilterToUri(item.field, "nome", item.value, uri);
    uri = appendStringFilterToUri(item.field, "descrizione", item.value, uri);
  });

  uri = uri.concat("&sort_field=", sort.field.toString());
  uri = uri.concat("&sort_direction=", sort.direction.toString());

  uri = uri.endsWith("?") ? uri.concat("skip=") : uri.concat("&skip=");

  return uri;
};

const getTipologie = (
  selectedId: number,
  page: number,
  sort: SortingModel,
  filter?: GridFilterModel
) => {
  let uri = setQueryParameters(filter, sort);

  let skip = 0;
  let take = TAKE_LIMIT;
  if (page > 0) skip = page * take;

  return getRequest<FetchPaginatedApiModel<BeneTipologiaModel[]>>(
    uri.concat(
      "&skip=",
      skip.toString(),
      "&take=",
      take.toString(),
      "&selectedId=",
      selectedId.toString()
    )
  );
};

const getTipologia = (id: string) => {
  return getRequest<BeneTipologiaModel>(
    api_url.concat("/api/tipologiabene/", id)
  );
};

const createTipologiaBene = (postdata: WithData) => {
  return postRequest(api_url.concat("/api/tipologiabene"), postdata.data);
};

const updateTipologia = (putdata: WithRecordID) => {
  return putRequest(
    api_url.concat("/api/tipologiabene/", putdata.recordID.toString()),
    putdata.data
  );
};

const deleteTipologia = (id: number) => {
  return deleteRequest(api_url.concat("/api/tipologiabene/", id.toString()));
};

export {
  getTipologie,
  getTipologia,
  createTipologiaBene,
  updateTipologia,
  deleteTipologia,
};
